<template>
  <el-container class="h-100% flex-col">
    <Notice v-if="noticebar && showNotice" />
    <el-container>
      <el-aside
        v-if="!isEmbedded || hostProps?.sidebar"
        :width="menuCollapse ? '60px' : '150px'"
        class="sticky top-0 h-70vh border-#E5E7EB border-r-1 border-l-0 border-y-0 border-solid"
      >
        <Menu />
      </el-aside>
      <el-container class="flex flex-col">
        <div class="!sticky !top-0 z-50 flex flex-col bg-#fff">
          <HbTitleBar
            v-if="statusbar && showHeader"
            :title="user.info.user?.enterpriseName || $t(`${route.meta.title}`)"
            :data="titleBarData"
            :recharge-text="$t('button.recharge')"
            :recharge-url="rechargeUrl"
            :disabledAllTooltip="true"
          />
          <Tab v-if="showTab"></Tab>
          <div v-if="showTab" class="h-12px bg-#f2f3f5"></div>
        </div>
        <el-main
          class="bg-#f2f3f5 flex-1 !overflow-unset"
          :class="[hostProps?.sidebar ? '!p-12px !pr-16px' : 'p-0']"
        >
          <router-view v-if="showContainer" v-slot="{ Component }">
            <keep-alive :include="['Send']">
              <component
                :key="
                  ['Draft', 'Send'].includes($route.name as string)
                    ? $route.name
                    : $route.fullPath
                "
                :is="Component"
              />
            </keep-alive>
          </router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script lang="ts" setup>
import { siteConfig } from '@/utils/site-config'
import { IS_GLOBAL } from '@/const'
import useMenu from '@/hooks/useMenu'
import { HbTitleBar } from '@hgj/storybrooke-business-tools'

import { useIframe } from '@/hooks/useIframe'
import { useWujie } from '@/hooks/useWujie'
import useUserStore from '@/store/useUserStore'
import useBaseStore from '@/store/useBaseStore'

const { __POWERED_BY_WUJIE__, props: wujieProps } = useWujie()
const iframe = useIframe()
const isEmbedded = computed(
  () =>
    Boolean(__POWERED_BY_WUJIE__) ||
    iframe.isFromAiAdmin ||
    iframe.isFromDetailPreviewHub,
)
const hostProps = computed(() =>
  iframe.isFromAiAdmin || iframe.isFromDetailPreviewHub
    ? iframe.props
    : wujieProps,
)
const statusbar = computed(
  () => !isEmbedded.value || hostProps.value?.statusbar,
)
const noticebar = computed(
  () => !isEmbedded.value || hostProps.value?.noticebar,
)
const route = useRoute()
const baseStore = useBaseStore()
const showNotice = computed(
  () =>
    ![
      'ModifyDelete',
      'PushSettings',

      'PriceTable',
      'UsageGuide',
      'BusinessData',

      'ManifestDetail',
      'AI',
    ].includes(route.name as string),
)
const { menuCollapse } = useMenu()
const user = useUserStore()
const showTab = computed(() =>
  [
    'Draft',
    'Send',
    'HistoryDetail',
    'SentHistory',
    'MasterHistory',
    'MasterHistoryDetail',
  ].includes(route.name as string),
)
const showHeader = computed(
  () => !['Detail', 'MasterDetail', 'AI'].includes(route.name as string),
)
const rechargeUrl = computed(() => {
  return siteConfig.rechargeUrl
})
const productCode = computed(() => {
  return baseStore.getProductCode
})
const titleBarData: any = computed(() => [
  {
    type: 'coupon',
    value: Number(user.info.couponCount) || 0,
    icon: 'icon-base-coupon-color',
    onClick: () => {
      window.open(
        `${siteConfig.couponUrl}?productCode=${productCode.value}`,
      )
    },
  },
  {
    type: 'haibi',
    value: IS_GLOBAL
      ? `${Number(user.info.seaCoin) || '0'} ${user.info.currency || ''}`
      : Number(user.info.seaCoin)?.toFixed(2) || '0.00',
    icon: 'icon-base-haibi-color',
  },
])

const showContainer = ref(true)

provide('forceRefresh', () => {
  showContainer.value = false
  nextTick(() => {
    showContainer.value = true
  })
})
</script>

<style scoped lang="scss">
.recharge-btn {
  width: 72px;
  height: 32px;
  background-image: linear-gradient(136deg, #ff7d31 0%, #ff5d31 100%);
  border-radius: 2px;
  border: unset;
  color: white;
  cursor: pointer;
  font-weight: 500;
}
</style>
